<script>
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/bootstrap-vue";
import VueJsonPretty from "vue-json-pretty";
import 'vue-json-pretty/lib/styles.css';
export default {
  name: "modalDebug",
  components: {
    VueJsonPretty,
    CModal, CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
  },
  props: {
    shown: Boolean,
    data: {
      type: Object,
      required: true,
    }
  },
  watch: {
    shown(value) {
      if(value === false) {
        this.reset();
      }
      else{
        this.$root.setModalHidden(false);
        this.mData = this.data;
      }
      this.showModal = value;
    },
    showModal(value) {
      this.$emit('update:shown', value);
    }
  },
  data() {
    return {
      showModal: false,
      mData: null,
    };
  },
  mounted() {
    this.showModal = this.shown;
  },
  methods:{
    reset(){

    },
  }
};
</script>

<template>
  <CModal :visible="showModal" :fullscreen="true" alignment="top" @close="showModal=false" backdrop="static">
    <CModalHeader>
      <CModalTitle>Debug Window</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <perfect-scrollbar class="h-100">
        <vue-json-pretty :data="mData" :deep="1" :editable="true" :showIcon="true"></vue-json-pretty>
      </perfect-scrollbar>
    </CModalBody>
    <CModalFooter>
      <div class="col text-end">
        <button class="btn btn-outline-dark btn-sm me-3" @click="showModal=false">{{ $t('common.btnClose') }}</button>
      </div>
    </CModalFooter>
  </CModal>
</template>

<style scoped>

</style>